import { Checkbox } from "@mui/material";
import { toggleObjectInArray } from "../../../../utils/objectToArrayConvert";

const TableBody = ({
  columns,
  rows,
  selectProps,
  setSelectedRows,
  selectedRows,
  getVarient,
}: any) => {
  const onToggleCb = (object: any) => {
    const updatedArray = toggleObjectInArray(
      selectedRows,
      object,
      selectProps.selectIdentifier
    );
    setSelectedRows(updatedArray);
  };

  return (
    <tbody>
      {rows.map((row: any, index: any) => {
        return (
          <tr
            className="bg-white"
            key={"table-row" + index}
            style={{ border: "1px solid #E9E9E9" }}
          >
            {selectProps.isSelectable ? (
              <td className={`${getVarient()}`}>
                <Checkbox
                  sx={{
                    // color: "rgb(0, 85, 150)",
                    "&.Mui-checked": {
                      color: "rgb(0, 85, 150)",
                    },
                  }}
                  checked={selectedRows.some(
                    (selectedRw: any) =>
                      selectedRw[selectProps.selectIdentifier] ===
                      row[selectProps.selectIdentifier]
                  )}
                  onChange={() => onToggleCb(row)}
                />
              </td>
            ) : null}

            {columns.map((col: any, i: any) => {
              return (
                <td
                  style={{ maxWidth: "300px" }}
                  key={"table-row" + i}
                  className={`${getVarient()} ${col?.color || ""}`}
                >
                  {col.renderLogic(row, index)}
                </td>
              );
            })}
          </tr>
        );
      })}
    </tbody>
  );
};

export default TableBody;
